var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMarkConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0H8V1H7V0ZM6 2V1H7V2H6ZM5 3V2H6V3H5ZM4 4H5V3H4V4ZM3 5H4V4H3V5ZM2 5V6H3V5H2ZM1 4H2V5H1V4ZM1 4H0V3H1V4Z",
    fill: "#14F079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkConnected);
export default __webpack_public_path__ + "static/media/check-mark-connected.ebbc007eaace5bfb4dc41f108232799d.svg";
export { ForwardRef as ReactComponent };